import { CampaignProcess } from 'utils/constants/campaign';

import { selectCampaignProcess } from 'store/models/createCampaign';
import { useSelector } from 'store/utils';

const useIsNewCampaign = (): boolean => {
    const campaignProcess = useSelector(selectCampaignProcess);

    return campaignProcess === CampaignProcess.Create;
};

export default useIsNewCampaign;
